import styled from 'styled-components';

export const GeneralGoalContainer = styled.div`
  height: 20rem;
  width: 32%;
  float: right;
  & .totalCoinsMessage {
    & .hefesto-title h5 {
      font-weight: normal;
    }
  }
  & .bar-graph-container {
    height: 20rem;
    max-width: 88%;
  }
  & .goal-title {
    margin-bottom: 1.2rem;
    margin-top: 1.2rem;
  }
  & .redeemCTA {
    text-align: center;
  }
  & .hefesto-button {
    width: 88%;
  }
  & .hefesto-legend-graph {
    & .recharts-custom-legend {
      & ul {
        & li {
          & .dot {
            border-radius: 0;
          }
        }
      }
    }
  }
`;
